<script setup lang="ts">

import type { IBankAccount } from '@domain/Carbucks';

const model = defineModel<IBankAccount>( { required: true });

</script>

<template>
    <div class="w-full
                bg-gradient-to-b from-gray-850 dark:!to-gray-900
                px-4 py-5 text-sm lg:text-base">
        <h1 class="text-base lg:text-lg 3xl:text-xl pb-3 flex justify-between items-center">
            Bank Account
            <RouterLink to="/carbucks/manage-bank-account"
                        class="flex items-center">
                <span class="text-xs uppercase dark:text-gray-500">Change</span>
                <Icon name="chevron-right" class="text-2xl" />
            </RouterLink>
        </h1>
        <div class="flex justify-between items-center gap-6 lg:gap-8 3xl:gap-10 tracking-wider">
            <div>
                <div class="text-xs lg:text-sm 3xl:text-base text-gray-500 -mt-0.5 uppercase">
                    BSB
                </div>
                <h1 class="text-sm lg:text-lg 3xl:text-xl">
                    {{ model.bsb }}
                </h1>
            </div>
            <div class="flex-1">
                <div class="text-xs lg:text-sm 3xl:text-base text-gray-500 -mt-0.5 uppercase">
                    Account Number
                </div>
                <h1 class="text-sm lg:text-lg 3xl:text-xl">
                    {{ model.accountNumber }}
                </h1>
            </div>
        </div>
    </div>   
</template>